/* eslint-disable @typescript-eslint/no-explicit-any */
import { Metadata } from 'next'
import BlogPostVM from './BlogPostVM'
import ImageComponent, { toImageComponent } from './ImageComponent'

export default interface SeoComponent {
  title: string
  description: string
  image: ImageComponent | null
  robots: string
  keywords: string
  structuredData: string
}

export enum SocialNetworkEnum {
  Facebook = 'Facebook',
  Twitter = 'Twitter',
}

export const toSeoComponent = (model: any): SeoComponent | null => {
  if (!model) return null
  const res: SeoComponent = {
    title: model.metaTitle,
    description: model.metaDescription,
    image: model.metaImage ? toImageComponent(model.metaImage) : null,
    robots: model.metaRobots,
    keywords: model.keywords,
    structuredData: model.structuredData,
  }

  return res
}

export const toMetadata = (model: SeoComponent | null | undefined, url?: string | null | undefined): Metadata => {
  const metadata: Metadata = {}
  if (!model) return metadata

  if (model.title) metadata.title = model.title
  if (model.description) metadata.description = model.description
  if (model.keywords) metadata.keywords = model.keywords
  if (url) metadata.alternates = { canonical: url }

  metadata.robots = {
    index: !model.robots?.includes('noindex'),
    follow: !model.robots?.includes('nofollow'),
  }

  metadata.openGraph = { type: 'website' }
  if (model.title) metadata.openGraph.title = model.title
  if (model.description) metadata.openGraph.description = model.description
  if (url) metadata.openGraph.url = url

  if (model.image) {
    metadata.openGraph.images = [
      {
        url: model.image.url,
        alt: model.image.alternativeText,
        type: model.image.mime,
        height: model.image.height,
        width: model.image.width,
      },
    ]
  }

  return metadata
}

export const toBlogPostMetadata = (model: BlogPostVM): Metadata => {
  const url = model?.slug ? '/blog/' + model.slug : null
  const metadata = toMetadata(model?.seo, url)
  if (!metadata) return metadata

  //if post is not published dont let robots find it
  if (!model.publishedAt) {
    metadata.robots = {
      index: false,
      follow: false,
    }
  }

  metadata.openGraph = {
    type: 'article',
    title: metadata.openGraph?.title || model.title,
    description: metadata.openGraph?.description || model.description,
    url: metadata.openGraph?.url || metadata.alternates?.canonical?.toString() || url || undefined,
    images: metadata.openGraph?.images || [],
    publishedTime: model.publishedAt || undefined,
    modifiedTime: model.updatedAt || undefined,
    authors: model.author?.name || undefined,
    section: model.category?.name,
    tags: model.topics?.length ? model.topics.map((t) => t.name) : undefined,
  }

  return metadata
}
